// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PinsMap from "../organisms/PinsMap.re.mjs";
import * as Core__Option from "@rescript/core/src/Core__Option.re.mjs";
import * as PkEventsList from "../organisms/PkEventsList.re.mjs";
import * as WaitForMessages from "../shared/i18n/WaitForMessages.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.re.mjs";
import * as PkLocationPageQuery_graphql from "../../__generated__/PkLocationPageQuery_graphql.re.mjs";

import { t } from '@lingui/macro'
;

var convertVariables = PkLocationPageQuery_graphql.Internal.convertVariables;

var convertResponse = PkLocationPageQuery_graphql.Internal.convertResponse;

RescriptRelay_Query.useQuery(convertVariables, PkLocationPageQuery_graphql.node, convertResponse);

RescriptRelay_Query.useLoader(convertVariables, PkLocationPageQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(PkLocationPageQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

RescriptRelay_Query.$$fetch(PkLocationPageQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.fetchPromised(PkLocationPageQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(PkLocationPageQuery_graphql.node, convertVariables);

function PkLocationPage(props) {
  var data = ReactRouterDom.useLoaderData();
  var match = usePreloaded(data.data);
  var fragmentRefs = match.fragmentRefs;
  var $$location = match.location;
  var events = match.events;
  var match$1 = React.useState(function () {
        
      });
  var setSelectedLocationId = match$1[1];
  var selectedLocationId = match$1[0];
  var onHoverLocation = function (locationId) {
    setSelectedLocationId(function (param) {
          return locationId;
        });
  };
  return JsxRuntime.jsx(WaitForMessages.make, {
              children: (function () {
                  return Core__Option.getOr(Core__Option.map($$location, (function (loc) {
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("h1", {
                                                                children: Core__Option.getOr(loc.name, "?"),
                                                                className: "text-lg font-semibold text-gray-900 dark:text-white"
                                                              }),
                                                          Core__Option.getOr(Core__Option.map(loc.details, (function (d) {
                                                                      return JsxRuntime.jsx("p", {
                                                                                  children: d,
                                                                                  className: "font-mono text-xs text-gray-500 dark:text-gray-400 mt-1"
                                                                                });
                                                                    })), null),
                                                          Core__Option.getOr(Core__Option.map(loc.address, (function (addr) {
                                                                      var defaultLink = Core__Option.flatMap(loc.links, (function (links) {
                                                                              return links[0];
                                                                            }));
                                                                      var mapsUrl = Core__Option.getOr(defaultLink, "https://maps.google.com/?q=" + addr);
                                                                      return JsxRuntime.jsx("a", {
                                                                                  children: addr,
                                                                                  className: "font-mono text-xs text-gray-500 dark:text-gray-400 mt-0.5 block hover:underline",
                                                                                  href: mapsUrl,
                                                                                  rel: "noopener noreferrer",
                                                                                  target: "_blank"
                                                                                });
                                                                    })), null)
                                                        ],
                                                        className: "px-4 py-3 border-b border-gray-200 dark:border-[#2a2b30]"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(PinsMap.make, {
                                                              connection: events.fragmentRefs,
                                                              onLocationClick: (function ($$location) {
                                                                  setSelectedLocationId(function (param) {
                                                                        return $$location.id;
                                                                      });
                                                                }),
                                                              selected: selectedLocationId
                                                            }),
                                                        className: "h-48 border-b border-gray-200 dark:border-[#2a2b30] flex-shrink-0"
                                                      }),
                                                  JsxRuntime.jsx(PkEventsList.make, {
                                                        events: fragmentRefs,
                                                        onHoverLocation: onHoverLocation,
                                                        showInlineCourts: true
                                                      })
                                                ],
                                                className: "flex flex-col h-full overflow-y-auto"
                                              });
                                  })), JsxRuntime.jsx("div", {
                                  children: t`Location not found`,
                                  className: "p-6 text-gray-500"
                                }));
                })
            });
}

var make = PkLocationPage;

export {
  make ,
}
/*  Not a pure module */
